<div *ngIf="disableEditing"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div class="modal-header bg-soft-info p-3">
    <h5 *ngIf="(newModel == true)" class="modal-title" id="exampleModalLabel"> <span i18n="@@">Create</span></h5>
    <h5 *ngIf="(newModel == false)" class="modal-title" id="exampleModalLabel"> <span i18n="@@"
            *ngIf="securityPermissionClientUpdate">Edit -</span>
        {{model.name}} {{model.lastName}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>
<div class="card-body p-3">
    <div class="text-center">
        <div class="profile-user position-relative avatar-lg p-1">
            <div class="avatar-title bg-light rounded-circle">
                <img [src]="profileImageURL" class="avatar-md rounded-circle object-cover">
            </div>

            <div class="p-0 rounded-circle profile-photo-edit">
                <label
                    *ngIf="((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client))) && (disableEditing === false)"
                    for="profile-img-file-input" class="profile-photo-edit avatar-xs" (click)="fileUpload.click()"
                    type="multipart/form-data">
                    <span class="avatar-title rounded-circle bg-light text-body">
                        <i class="ri-camera-fill"></i>
                    </span>
                </label>
                <input accept="image/png, image/jpeg" style="display: none;" class="file-input" type="file"
                    (change)="uploadPhotoDirectly(model, $event, enumEntityFileType.ProfilePhoto)" #fileUpload>
            </div>
        </div>
    </div>
</div>

<div class="card-header mt-3">

    <ul ngbNav #customNav="ngbNav" [(activeId)]="activeTab"
        class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0center justify-content-center"
        role="tablist">
        <!-- Personal Info -->
        <li [ngbNavItem]="1" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="fas fa-home"></i>
                <div i18n="@@">Personal Info</div>
            </a>
            <ng-template ngbNavContent>
                <div class="row pb-2">

                    <div class="col-12  col-lg-4">
                        <div class="mb-3">
                            <label i18n="@@">First Name</label>
                            <input required #name="ngModel" [patterns]="stringPattern" mask='%* %* %* %* %* %*'
                                [dropSpecialCharacters]="false"
                                [ngClass]="{ 'is-invalid': (name.invalid && ((name.dirty || name.touched) || submitted == true))}"
                                class="form-control" type="text" placeholder="Enter First Name" i18n-placeholder="@@"
                                [(ngModel)]="model.name" (keypress)="modalEdited = true"
                                [disabled]=" disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                            <div *ngIf="(name.invalid && ((name.dirty || name.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="name.errors?.['required']">
                                    <div i18n="@@">First Name Required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12  col-lg-4">
                        <div class="mb-3">
                            <label i18n="@@">Middle Name</label>
                            <input [patterns]="stringPattern" mask='%* %* %* %* %* %*' [dropSpecialCharacters]="false"
                                class="form-control" type="text" placeholder="Enter Middle Name" i18n-placeholder="@@"
                                [(ngModel)]="model.middleName" (keypress)="modalEdited = true"
                                [disabled]=" disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />

                        </div>
                    </div>
                    <div class="col-12  col-lg-4">
                        <div class="mb-3">
                            <label i18n="@@">Last Name</label>
                            <input required #lastName="ngModel" [patterns]="stringPattern" mask='%* %* %* %* %* %*'
                                [dropSpecialCharacters]="false"
                                [ngClass]="{ 'is-invalid': (lastName.invalid && ((lastName.dirty || lastName.touched) || submitted == true))}"
                                class="form-control" type="text" placeholder="Enter Last Name" i18n-placeholder="@@"
                                [(ngModel)]="model.lastName" (keypress)="modalEdited = true"
                                [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                            <div *ngIf="(lastName.invalid && ((lastName.dirty || lastName.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="lastName.errors?.['required']">
                                    <div i18n="@@">Last Name Required</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12  col-lg-4 mb-3">
                        <label for="creditcardExpireInput" class="form-label" i18n="@@">Date of Birth</label>

                        <div class=" input-group d-flex form-control" style="padding: 0%;"
                            [ngClass]="{ 'is-invalid': ((dateOfBirth.invalid) && ((dateOfBirth.dirty || dateOfBirth.touched) || submitted == true))}">
                            <input class=" flex-grow-1 form-control" style="border-width: 0;" required
                                [pattern]="datePattern" #dateOfBirth="ngModel" type="text"
                                [dropSpecialCharacters]="false" [(ngModel)]="model.dateOfBirth" placeholder="DD/MM/YYYY"
                                mask="00/00/0000" i18n-placeholder="@@"
                                [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                            <span class=" input-group-text ri-calendar-2-line "
                                style="  align-self: center; border-width: 0;" type="text" mwlFlatpickr [disableMobile]="true"
                                [(ngModel)]="model.dateOfBirth" [dateFormat]="'d/m/Y'"
                                [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))"></span>

                        </div>

                        <div *ngIf="((dateOfBirth.invalid ) && ((dateOfBirth.dirty || dateOfBirth.touched) || submitted == true))"
                            class='invalidInputTextMessage'>
                            <div *ngIf="dateOfBirth.errors?.['required'] else elseDoBInvalid">
                                <div i18n="@@">Date of Birth Required </div>
                            </div>
                            <ng-template #elseDoBInvalid>
                                <div *ngIf="dateOfBirth.invalid ">
                                    <div i18n="@@">Date of Birth Invalid</div>
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <div class=" col-12 col-sm-6  col-lg-4">
                        <div class="mb-3">
                            <label i18n="@@">Gender</label>
                            <app-ng-select-layout
                                [disableInput]=" disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))"
                                [placeHolderText]="'Select Gender'" [invalidText]="'Gender Required'"
                                [(model)]="model.gender" [items]="genderList" [includeValidation]="true"
                                [submitted]="submitted"></app-ng-select-layout>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <div class="mb-3">
                            <label i18n="@@">Marital Status</label>
                            <app-ng-select-layout
                                [disableInput]=" disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))"
                                [placeHolderText]="'Select Marital Status'" [invalidText]="'Marital Status Required'"
                                [(model)]="model.maritalStatus" [items]="maritalList" [includeValidation]="true"
                                [submitted]="submitted"></app-ng-select-layout>
                        </div>
                    </div>

                    <div class="mb-3">
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1" i18n="@@">Client Information</h4>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="mb-3">
                            <label i18n="@@">Email</label>
                            <input class="form-control" type="text" required [pattern]=emailPattern #email="ngModel"
                                [ngClass]="{ 'is-invalid': ((email.invalid) && ((email.dirty || email.touched) || submitted == true))}"
                                placeholder="Enter Email" i18n-placeholder="@@" [(ngModel)]="model.email"
                                (keypress)="modalEdited = true"
                                [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                            <div *ngIf="(email.invalid && ((email.dirty || email.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <!-- this is the style of form-invalid -->
                                <div *ngIf="email.errors?.['required'] else elseEmail">
                                    <div i18n="@@">Email Required</div>
                                </div>
                                <ng-template #elseEmail>
                                    <div *ngIf="email.invalid">
                                        <div i18n="@@">Email Invalid</div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="mb-3">
                            <label i18n="@@">Phone Number</label>
                            <input class="form-control" type="text" #phone="ngModel" mask="(000) 000-0000"
                                [dropSpecialCharacters]="false"
                                [ngClass]="{ 'is-invalid': ((phone.invalid) && ((phone.dirty || phone.touched) || submitted == true))}"
                                placeholder="Enter Phone Number" i18n-placeholder="@@" [(ngModel)]="model.phoneNumber"
                                (keypress)="modalEdited = true"
                                [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                            <div *ngIf="(phone.invalid && ((phone.dirty || phone.touched) || submitted == true))"
                                class='invalidInputTextMessage'>

                                <div *ngIf="phone.invalid">
                                    <div i18n="@@">Phone Number Invalid</div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1" i18n="@@">Default Matter</h4>
                        </div>
                    </div>


                    <div class="col-lg-6">
                        <div class="mb-3">
                            <label i18n="@@">Matter Number</label>
                            <input class="form-control" type="text" placeholder="Enter Matter Number"
                                i18n-placeholder="@@" [(ngModel)]="model.matterNumber" (keypress)="modalEdited = true"
                                [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))"
                                [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="mb-3">
                            <label i18n="@@"> Date of Loss</label>

                            <div class=" input-group d-flex form-control" style="padding: 0;"
                                [ngClass]="{'is-invalid': ((dateOfLossVal.invalid )&& ((dateOfLossVal.dirty || dateOfLossVal.touched) || submitted == true))  }">
                                <input class=" flex-grow-1 form-control" style="border-width: 0;" type="text"
                                    [dropSpecialCharacters]="false" [(ngModel)]="model.dateOfLoss"
                                    placeholder="DD/MM/YYYY" mask="00/00/0000" i18n-placeholder="@@"
                                    (keypress)="modalEdited = true"
                                    [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                <span class=" input-group-text ri-calendar-2-line " #dateOfLossVal="ngModel" required
                                    [pattern]="datePattern" style="  align-self: center;border-width: 0;" type="text"
                                    mwlFlatpickr [disableMobile]="true" [(ngModel)]="model.dateOfLoss" [dateFormat]="'d/m/Y'"
                                    [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))"></span>

                            </div>
                            <div *ngIf="((dateOfLossVal.invalid ) && ((dateOfLossVal.dirty || dateOfLossVal.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="dateOfLossVal.errors?.['required'] else elseDoLInvalid">
                                    <div i18n="@@">Date of Loss Required </div>
                                </div>
                                <ng-template #elseDoLInvalid>
                                    <div *ngIf="dateOfLossVal.invalid ">
                                        <div i18n="@@">Date of Loss Invalid</div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <!-- Address Info -->
        <li [ngbNavItem]="2" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <div i18n="@@fo">Address Information</div>
            </a>
            <ng-template ngbNavContent>
                <div class="pb-2">
                    <app-address [addressModel]="model.address" [includeValidation]="true" [submitted]="submitted"
                        (keypress)="modalEdited = true" (change)="modalEdited = true"
                        [disableInputs]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate))"></app-address>
                </div>
            </ng-template>
        </li>
        <!-- Legal Info -->
        <li [ngbNavItem]="3" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <div i18n="@@">Legal Details</div>
            </a>
            <ng-template ngbNavContent>
                <ul ngbNav #legalNav="ngbNav" [activeId]="1"
                    class="nav nav-tabs-custom  card-header-tabs border-bottom-0center justify-content-center"
                    role="tablist" style="margin-top: 0rem;">

                    <li [ngbNavItem]="1" class="nav-item">
                        <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                            <i class="far fa-user"></i>
                            <div i18n="@@">Identification</div>
                        </a>
                        <ng-template ngbNavContent>
                            <div class="row mt-4 ">
                                <div class="col-lg-12">
                                    <div class="mb-3">
                                        <label i18n="@@">Driver's License Number</label>
                                        <input class="form-control" type="text"
                                            placeholder="Enter Driver's License Number" i18n-placeholder="@@"
                                            [(ngModel)]="model.driverLicense" (keypress)="modalEdited = true"
                                            [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />

                                    </div>
                                    <div class="mb-3">
                                        <label i18n="@@">License Plate </label>
                                        <input mask='A* A* A* A* A* A*' [dropSpecialCharacters]="false"
                                            class="form-control" type="text" placeholder="Enter License Plate"
                                            i18n-placeholder="@@" [(ngModel)]="model.licensePlate"
                                            (keypress)="modalEdited = true"
                                            [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                    </div>
                                    <div class="mb-3">
                                        <label i18n="@@">Health Card Number</label>
                                        <input class="form-control" type="text" placeholder="Enter Health Card Number"
                                            i18n-placeholder="@@" [(ngModel)]="model.healthCardNumber"
                                            (keypress)="modalEdited = true"
                                            [disabled]="disableInputs ||  !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                    </div>
                                    <div class="mb-3">
                                        <label i18n="@@">SIN Number</label>
                                        <input mask='000-000-0000' [dropSpecialCharacters]="false" #sin="ngModel"
                                            class="form-control" type="text" placeholder="Enter SIN"
                                            [ngClass]="{ 'is-invalid': ((invalidSin) && (model.sin && model.sin != ''))}"
                                            i18n-placeholder="@@" [(ngModel)]="model.sin"
                                            (keypress)="modalEdited = true;"
                                            [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                        <div *ngIf="(invalidSin) && (model.sin && model.sin != '') "
                                            class='invalidInputTextMessage'>
                                            <div i18n="@@">SIN Number Invalid</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="2" class="nav-item">
                        <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                            <i class="far fa-user"></i>
                            <div i18n="@@">Insurance</div>
                        </a>
                        <ng-template ngbNavContent>
                            <div class="row mt-4 ">
                                <div class="col-lg-12 col-xl-6">
                                    <div class="mb-3">
                                        <label i18n="@@">Insurance Company</label>
                                        <input #insuranceCompany="ngModel" class="form-control" type="text"
                                            placeholder="Enter Insurance Company" i18n-placeholder="@@"
                                            [(ngModel)]="model.insuranceCompany.name" (keypress)="modalEdited = true"
                                            [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                    </div>
                                </div>
                                <div class="col-lg-12 col-xl-6">
                                    <div class="mb-3">
                                        <label i18n="@@">Policy Holder</label>
                                        <input #policyHolder="ngModel" class="form-control" type="text"
                                            placeholder="Enter Policy Holder's Name" i18n-placeholder="@@"
                                            [(ngModel)]="model.insuranceCompany.policyHolder"
                                            (keypress)="modalEdited = true"
                                            [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                    <div class="mb-3">
                                        <label i18n="@@">Claim Number</label>
                                        <input #claimNumber="ngModel" class="form-control" type="text"
                                            placeholder="Enter Claim Number" i18n-placeholder="@@"
                                            [(ngModel)]="model.claimNumber" (keypress)="modalEdited = true"
                                            [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                    <div class="mb-3">
                                        <label i18n="@@">Policy Number</label>
                                        <input #policyNumber="ngModel" class="form-control" type="text"
                                            placeholder="Enter Policy Number" i18n-placeholder="@@"
                                            [(ngModel)]="model.insuranceCompany.policyNumber"
                                            (keypress)="modalEdited = true"
                                            [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xl-4 mb-3">
                                    <label i18n="@@">AB Adjuster</label>
                                    <input #abAdjusterName="ngModel" class="form-control" type="text"
                                        placeholder="Enter AB Adjuster" i18n-placeholder="@@"
                                        [(ngModel)]="model.abAdjusterName" (keypress)="modalEdited = true"
                                        [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                </div>


                                <div class="col-lg-6 col-xl-4 mb-3">
                                    <label i18n="@@">BI Adjuster</label>
                                    <input #biAdjusterName="ngModel" class="form-control" type="text"
                                        placeholder="Enter BI Adjuster" i18n-placeholder="@@"
                                        [(ngModel)]="model.biAdjusterName" (keypress)="modalEdited = true"
                                        [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                </div>

                                <div class="col-lg-6 col-xl-4">
                                    <div class="mb-3">
                                        <label i18n="@@Contac">Email </label>
                                        <input class="form-control" type="text" [pattern]=emailPattern
                                            #emailInsurance="ngModel" placeholder="Enter Email" i18n-placeholder="@@"
                                            [(ngModel)]="model.insuranceCompany.email"
                                            [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))"
                                            (keypress)="modalEdited = true" />
                                        <div *ngIf="(emailInsurance.invalid && ((emailInsurance.dirty || emailInsurance.touched) || submitted == true))"
                                            class='invalidInputTextMessage'>
                                            <div *ngIf="emailInsurance.errors?.['required'] else elseEmail">

                                            </div>
                                            <ng-template #elseEmail>
                                                <div *ngIf="emailInsurance.invalid">
                                                    <div i18n="@@">Email Invalid</div>
                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-4">
                                    <div class="mb-3">
                                        <label i18n="@@">Phone Number</label>
                                        <input class="form-control" type="text" #phone="ngModel" mask="(000) 000-0000"
                                            [dropSpecialCharacters]="false" placeholder="Enter Phone Number"
                                            i18n-placeholder="@@" [(ngModel)]="model.insuranceCompany.phoneNumber"
                                            (keypress)="modalEdited = true"
                                            [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                        <div *ngIf="(phone.invalid && ((phone.dirty || phone.touched) || submitted == true))"
                                            class='invalidInputTextMessage'>
                                            <div *ngIf="phone.errors?.['required'] else elsePhone">

                                            </div>
                                            <ng-template #elsePhone>
                                                <div *ngIf="phone.invalid">
                                                    <div i18n="@@">Phone Number Invalid</div>
                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                                <app-address [addressModel]="model.insuranceCompany" [submitted]="submitted"
                                    (keypress)="modalEdited = true" (change)="modalEdited = true"
                                    [disableInputs]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate))"></app-address>

                            </div>

                        </ng-template>
                    </li>
                    <li [ngbNavItem]="3" class="nav-item">
                        <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                            <i class="far fa-user"></i>
                            <div i18n="@@">Opposing Counsel</div>
                        </a>
                        <ng-template ngbNavContent>
                            <div class="row mt-4 ">
                                <div class="col-lg-12">
                                    <div class="mb-3">
                                        <label i18n="@@">Name</label>
                                        <input class="form-control" type="text" placeholder="Enter Name"
                                            i18n-placeholder="@@" [(ngModel)]="model.opposingCounsel.name"
                                            (keypress)="modalEdited = true"
                                            [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="mb-3">
                                        <label i18n="@@">Phone Number</label>
                                        <input class="form-control" type="text" placeholder="Enter Phone Number"
                                            i18n-placeholder="@@" [(ngModel)]="model.opposingCounsel.phoneNumber"
                                            (keypress)="modalEdited = true"
                                            [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="mb-3">
                                        <label i18n="@@">Email</label>
                                        <input class="form-control" type="text" placeholder="Enter Email"
                                            i18n-placeholder="@@" [(ngModel)]="model.opposingCounsel.email"
                                            (keypress)="modalEdited = true"
                                            [disabled]="disableInputs ||!((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate) || (newModel === false && (loginType == LoginType.Client)))" />
                                    </div>
                                </div>

                                <app-address [addressModel]="model.opposingCounsel.address" [submitted]="submitted"
                                    (keypress)="modalEdited = true" (change)="modalEdited = true"
                                    [disableInputs]="disableInputs ||!((newModel === false && securityPermissionClientUpdate) || (newModel === true && securityPermissionClientCreate))"></app-address>
                            </div>

                        </ng-template>
                    </li>
                </ul>
                <div class="tab-model">
                    <div [ngbNavOutlet]="legalNav"></div>
                </div>
            </ng-template>
        </li>
        <!-- Attachments -->
        <li [ngbNavItem]="4" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <span i18n="@@">Attachments</span>
            </a>

            <ng-template ngbNavContent>
                <span *ngIf="model.id != undefined">
                    <app-file-management [entityId]="model.id" [entityTypeId]="entityTypeId"
                        [entityName]="model.fullName"></app-file-management>
                </span>
                <span *ngIf="model.id == undefined">
                    <app-file-management [filesIdsToAdd]="model.fileUpload.fileIdsToAdd"
                        (filesIdsToAddChanged)="onNewModalEntityFileIdsAdded(model,$event)"
                        [entityName]="model.fullName"
                        [entityFiles]="model.fileUpload.entityFiles"></app-file-management>
                </span>
            </ng-template>

        </li>
        <!-- Recent Activity -->
        <li [ngbNavItem]="5" *ngIf="(newModel != true)" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <span i18n="@@">Recent Activity</span>
            </a>

            <ng-template ngbNavContent>
                <app-timeline-note-list [displayFilterType]="true" [display]="2"
                    [timelineOwnerId]="model.id"></app-timeline-note-list>
            </ng-template>

        </li>
        <!-- Requisition Info -->
        <li [ngbNavItem]="6" *ngIf="(newModel != true)" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <span i18n="@@">Requisition History</span>
            </a>

            <ng-template ngbNavContent>
                <app-requisition-list [display]=0 [clientLimitedSearch]="model.id"
                    [customListLayOut]="tableConfig"></app-requisition-list>
            </ng-template>

        </li>
        <!-- Signature Info -->
        <li [ngbNavItem]="7" *ngIf="(newModel != true) && (loginType == LoginType.User)" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <div i18n="@@">Signature</div>
            </a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-auto mt-2 col-md-12 row d-flex m-0 p-0">
                        <div class="col-lg-6 mb-3 ">

                            <div class="card-header align-items-center d-flex mb-3">
                                <h4 class="card-title mb-0 flex-grow-1" i18n="@@">
                                    Signature
                                </h4>
                                <!-- <div *ngIf="loginType == clientLoginType "..
                                    style="text-align: end; top:-0.5rem; position:relative;">
                                    <button
                                        class="btn badge bg-light text-primary fs-12"
                                        (click)="openSignaturePadModal(true)">
                                        <div style="display: inline-flex;">
                                            <i
                                                class="ri-edit-box-line align-bottom me-1"></i>
                                            <div style="text-align: center;"
                                                i18n="@@">
                                                Edit
                                            </div>
                                        </div>
                                    </button>
                                </div> -->
                            </div>

                            <div class="border shadow text-center" style="background-color: #fff;">
                                <img [src]="signaturePNGTransform()"
                                    style="padding: 10px; height:320px; max-width: 100%;" />
                            </div>
                        </div>
                        <div class="col-lg-6 mb-3">

                            <div class="card-header align-items-center d-flex mb-3">
                                <h4 class="card-title mb-0 flex-grow-1" i18n="@@">
                                    Initials
                                </h4>
                                <!-- <div *ngIf="loginType == clientLoginType "
                                    style="text-align: end; top:-0.5rem; position:relative;">
                                    <button class="btn badge bg-light text-primary fs-12"
                                        (click)="openSignaturePadModal(false)">
                                        <div style="display: inline-flex;">
                                            <i class="ri-edit-box-line align-bottom me-1"></i>
                                            <div style="text-align: center;" i18n="@@">
                                                Edit
                                            </div>
                                        </div>
                                    </button>
                                </div> -->
                            </div>

                            <div class="border shadow text-center" style="background-color: #fff;">
                                <img [src]="initialPNGTransform()"
                                    style="padding: 10px; height:320px; max-width: 100%;" />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <!-- Admin Controls-->
        <li [ngbNavItem]="8" *ngIf="securityRoleIsAdmin && (newModel != true) && (loginType == LoginType.User)"
            class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <div i18n="@@">Admin Controls</div>
            </a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="d-flex gap-2">
                        <div class="col-lg-6 mb-3 ps-2">
                            <label i18n="@@">Email</label>
                            <input class="form-control" type="text" required [pattern]="emailPattern" #email="ngModel"
                                [ngClass]="{ 'is-invalid': (email.invalid && ((email.dirty || email.touched) || submitted == true))}"
                                placeholder="Enter Email" i18n-placeholder="@@" [(ngModel)]="model.email"
                                (keypress)="modalEdited = true"
                                [disabled]="disableInputs || !((newModel === false && securityPermissionClientUpdate))" />
                            <div *ngIf="(email.invalid && ((email.dirty || email.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="email.errors?.['required'] else elseEmail">
                                    <div i18n="@@">Email is Required</div>
                                </div>
                                <ng-template #elseEmail>
                                    <div *ngIf="email.invalid">
                                        <div i18n="@@">Email Invalid</div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>

                        <div class="col-lg-6 mb-3 ">
                            <label type="password" for="newpasswordInput" class="form-label" i18n="@@">Set New
                                Password</label>
                            <div class="position-relative auth-pass-inputgroup" style="padding-right: 1rem;">
                                <input class="form-control" [(ngModel)]="adminNewPassword"
                                    [type]="adminPasswordFieldType ? 'text' : 'password'"
                                    placeholder="Enter new password" i18n-placeholder="@@" />
                                <button style="padding-right: 2rem;"
                                    class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                    type="button" id="password-addon"><i class="mdi align-middle"
                                        [ngClass]="{'mdi-eye-off-outline': adminPasswordFieldType, 'mdi-eye-outline': !adminPasswordFieldType}"
                                        (click)="adminPasswordFieldType = !adminPasswordFieldType"></i></button>
                            </div>
                            <div *ngIf="adminPasswordEdited " class='invalidInputTextMessage'>
                                <div *ngIf="(adminNewPassword == undefined || adminNewPassword =='')">
                                    <div i18n="@@">New Password Required</div>
                                </div>
                                <div *ngIf="adminNewPassword && adminNewPassword.length < 6">
                                    <div i18n="@@">New password must be atleast 6 characters long</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex gap-2">
                        <div class="col-lg-6 mb-3 ps-2">
                            <label i18n="@@">Status</label>
                            <app-ng-select-layout [placeHolderText]="'Select Gender'" [invalidText]="'Status Required'"
                                [(model)]="model.status" [items]="statusList" [includeValidation]="true"
                                [submitted]="submitted"></app-ng-select-layout>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <!-- Client Password Reset -->
        <li [ngbNavItem]="9" *ngIf="(newModel != true) && (loginType == LoginType.Client)" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <div i18n="@@">Change Password</div>
            </a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-12  col-lg-4 mt-lg-0 mb-3">
                        <div>
                            <label class="form-label" i18n="@@">Old
                                Password</label>
                            <div class="position-relative auth-pass-inputgroup">
                                <input class="form-control" [(ngModel)]="clientOldPassword"
                                    [type]="oldPasswordFieldType ? 'text' : 'password'" placeholder="Enter old password"
                                    i18n-placeholder="@@" (change)="clientOldPasswordInvalid = false" />
                                <button
                                    class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                    type="button" id="password-addon"><i class="mdi align-middle"
                                        [ngClass]="{'mdi-eye-off-outline': oldPasswordFieldType, 'mdi-eye-outline': !oldPasswordFieldType}"
                                        (click)="oldPasswordFieldType = !oldPasswordFieldType"></i></button>
                            </div>
                            <div *ngIf="clientPasswordEdited" class='invalidInputTextMessage'>
                                <div *ngIf="(clientOldPassword == undefined || clientOldPassword =='')">
                                    <div i18n="@@">Old Password Required</div>
                                </div>
                                <div *ngIf="(clientOldPasswordInvalid)">
                                    <div i18n="@@">Invalid Password</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 mt-lg-0 mb-3">
                        <div>
                            <label type="password" for="newpasswordInput" class="form-label" i18n="@@">New
                                Password</label>
                            <div class="position-relative auth-pass-inputgroup">
                                <input class="form-control" [(ngModel)]="clientNewPassword"
                                    [type]="newPasswordFieldType ? 'text' : 'password'" placeholder="Enter new password"
                                    i18n-placeholder="@@" />
                                <button
                                    class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                    type="button" id="password-addon"><i class="mdi align-middle"
                                        [ngClass]="{'mdi-eye-off-outline': newPasswordFieldType, 'mdi-eye-outline': !newPasswordFieldType}"
                                        (click)="newPasswordFieldType = !newPasswordFieldType"></i></button>
                            </div>
                            <div *ngIf="clientPasswordEdited" class='invalidInputTextMessage'>
                                <div *ngIf="(clientNewPassword == undefined || clientNewPassword =='')">
                                    <div i18n="@@">New Password Required</div>
                                </div>
                                <div *ngIf="clientNewPassword && clientNewPassword.length < 6">
                                    <div i18n="@@">New password must be atleast 6 characters long</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 mt-lg-0 mb-3">
                        <label type="password" for="confirmpasswordInput" class="form-label" i18n="@@">Confirm
                            Password</label>
                        <div class="position-relative auth-pass-inputgroup">
                            <input class="form-control" [(ngModel)]="clientConfirmPassword"
                                [type]="confirmPasswordFieldType ? 'text' : 'password'"
                                placeholder="Confirm new password" i18n-placeholder="@@" />
                            <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                type="button" id="password-addon"><i class="mdi align-middle"
                                    [ngClass]="{'mdi-eye-off-outline': confirmPasswordFieldType, 'mdi-eye-outline': !confirmPasswordFieldType}"
                                    (click)="confirmPasswordFieldType = !confirmPasswordFieldType"></i></button>
                        </div>
                        <div *ngIf="clientPasswordEdited" class='invalidInputTextMessage'>
                            <div *ngIf="(clientConfirmPassword == undefined || clientConfirmPassword =='')">
                                <div i18n="@@">Confirming Password is Required</div>
                            </div>
                            <div *ngIf="clientNewPassword && (clientConfirmPassword != clientNewPassword)">
                                <div i18n="@@">Confirming Password and New Password must match</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>


</div>
<div class="card-body p-4 ">

    <div [ngbNavOutlet]="customNav" style=" overflow: scroll; min-height: 26rem; max-height:fit-content; "></div>

    <div *ngIf="!disableInputs" class="hstack justify-content-end">
        <button [disabled]="disableEditing" *ngIf="(newModel == true) && securityPermissionClientCreate" type="button"
            class="btn btn-success" id="add-btn" (click)="onSave()" i18n="@@">Create</button>
        <div *ngIf="customNav.activeId != 7 && customNav.activeId != 8 && customNav.activeId != 9">
            <button [disabled]="disableEditing"
                *ngIf="loginType == LoginType.Client || ((newModel == false ) && securityPermissionClientUpdate)"
                type="button" class="btn btn-success" id="add-btn" (click)="onSave()" i18n="@@">Update</button>
        </div>
        <div *ngIf="customNav.activeId == 7" class="d-flex flex-grow-1 justify-content-between">
            <div *ngIf="securityPermissionClientUpdate">
                <div style="display: flex; justify-content: end;">
                    <button class="btn btn-success createFile-modal " (click)="requestSignature()">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        <span i18n="@@"> Request Signature </span>
                    </button>
                </div>
            </div>
            <button [disabled]="disableEditing"
                *ngIf="loginType == LoginType.Client || ((newModel == false ) && securityPermissionClientUpdate)"
                type="button" class="btn btn-success" id="add-btn" (click)="onSave()" i18n="@@">Update</button>
        </div>
        <div *ngIf="customNav.activeId == 8" class="d-flex flex-grow-1 justify-content-between">
            <div *ngIf="securityPermissionClientUpdate">
                <div style="display: flex; justify-content: end;">
                    <button class="btn btn-success createFile-modal " (click)="sendClientPasswordReset()">
                        <span i18n="@@"> Send Password Reset</span>
                    </button>
                </div>
            </div>
            <button [disabled]="disableEditing"
                *ngIf="loginType == LoginType.Client || ((newModel == false ) && securityPermissionClientUpdate)"
                type="button" class="btn btn-success" id="add-btn" (click)="updateAdminControl()"
                i18n="@@">Update</button>
        </div>
        <div *ngIf="customNav.activeId == 9">
            <button [disabled]="disableEditing"
                *ngIf="loginType == LoginType.Client || ((newModel == false ) && securityPermissionClientUpdate)"
                type="button" class="btn btn-success" id="add-btn" (click)="updatePassword()" i18n="@@">Update</button>
        </div>
    </div>
</div>